import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-side-filter-modal',
  templateUrl: './side-filter-modal.component.html',
  styleUrls: ['./side-filter-modal.component.scss'],
})
export class SideFilterModalComponent implements OnInit {
  @Input() active = false;
  @Input() title: string = 'Filtrar listagem';
  @Input() loading: boolean = false;
  @Input() formGroup!: FormGroup;
  @Input() applyButtonText: string = 'Aplicar filtros';
  @Input() resetButtonText: string = 'Limpar filtros';
  @Input() showApplyButton: boolean = true;
  @Input() showResetButton: boolean = true;
  @Input() paddingBottom?: string;
  @Input() padding?: string;
  @Input() disableApplyButton: boolean = false;
  /** Se true (padrão), o modal fecha ao clicar em Aplicar. Se false, o pai controla o fechamento (ex.: após sucesso da API). */
  @Input() closeOnApply: boolean = true;

  @Output() onClose = new EventEmitter<void>();
  @Output() onApply = new EventEmitter<void>();
  @Output() onReset = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  close() {
    this.onClose.emit();
  }

  handleFormEnter(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      if (this.showApplyButton) {
        this.apply();
      }
    }
  }

  apply() {
    if (!this.loading) {
      if (this.closeOnApply) {
        this.close();
      }
      this.onApply.emit();
    }
  }

  reset() {
    this.close();
    this.onReset.emit();
  }
}
